import React from 'react';
import './style.scss';

const MultiColorsLoader: React.FC = () => {
    return <div className="multi-colors-loader loader-box-profile" />;
};

export default MultiColorsLoader;
